<template>
    <div class="person">
        <div class="condition">
            <div class="item">
                <div class="label">综合查询:</div>
                <el-input v-model="conditionData.Multiple" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">开始日期:</div>
                <el-date-picker
                v-model="conditionData.StartTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>
            <div class="item">
                <div class="label">结束日期:</div>
                <el-date-picker
                v-model="conditionData.EndTime"
                size="small"
                type="date"
                placeholder="选择日期">
                </el-date-picker>
            </div>
               
            <div class="item">
                <div class="label">案件状态:</div>
                <el-select v-model="conditionData.CaseType" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in catastyppes"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">案件类型:</div>
                <el-select v-model="conditionData.caseType" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in dcTaskActionList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">财务状态:</div>
                <el-select v-model="conditionData.financeState" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in standTermStatus"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <div class="item">
                <div class="label">委托主体:</div>
                <el-input v-model="conditionData.Client" size="small" placeholder="请输入"></el-input>
            </div>
            <div class="item">
                <div class="label">是否已结算:</div>
                <el-select v-model="conditionData.isEndCount" size="small" placeholder="请选择">
                    <el-option
                    v-for="item in isEndCountList"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value">
                    </el-option>
                </el-select>
            </div>
            <!-- <div class="item">
                <div class="label">委托主体:</div>
                <el-input v-model="conditionData.Client" size="small" placeholder="请输入"></el-input>
            </div> -->
            <div class="btns">
                <el-button type="primary" size="small" @click="selectData()">查询</el-button>
                <el-button type="" size="small" @click="reset()">重置</el-button>
            </div>
        </div>

        <div class="table">
            <div class="handle">
                <el-button type="" icon="el-icon-refresh-left" size="small" @click="loadingData()">刷新列表</el-button>
                <div>
                    <el-button type="success" icon="el-icon-download" size="small" @click="getExcel">导出excel</el-button>
                    <!-- <el-button type="primary" icon="el-icon-edit" size="small" @click="updateDialogShow()">修改人员信息</el-button> -->
                </div>
            </div>
            <el-table
                :data="tableData"
                border
                :header-cell-style="tableHeaderColor"
                height="550"
                style="width: 100%">
                
                <el-table-column
                prop="assetsNO"
                label="案件ID"
                align="center"
                width="140"
                >
                </el-table-column>
                <el-table-column
                prop="entrust"
                label="委托日期"
                align="center"
                width="140"
                >
                </el-table-column>
                <el-table-column
                prop="entrustPeople"
                label="委托主体"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="mechanism"
                label="展业机构"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="reportNo"
                label="报案号"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="caseNo"
                label="报告编号"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="caseName"
                label="案件名称"
                align="center"
                min-width="200"
                
                >
                </el-table-column>
                <el-table-column
                prop="caseType"
                label="案件类型"
                align="center"
                min-width="100"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.caseType==0"></span>
                    <span v-if="scope.row.caseType==1">财产险</span>
                    <span v-if="scope.row.caseType==2">资产评估</span>
                    <span v-if="scope.row.caseType==3">调查</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="caseStatus"
                label="案件状态"
                align="center"
                width="140"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.caseStatus==10">已指派待作业</span>
                    <span v-if="scope.row.caseStatus==20">作业中</span>
                    <span v-if="scope.row.caseStatus==30">已作业待审核</span>
                    <span v-if="scope.row.caseStatus==35">审核退回</span>
                    <span v-if="scope.row.caseStatus==40">待归档</span>
                    <span v-if="scope.row.caseStatus==60">归档待审核</span>
                    <span v-if="scope.row.caseStatus==64">归档不通过</span>
                    <span v-if="scope.row.caseStatus==100">完成</span>
                    <span v-if="scope.row.caseStatus==101">待归档</span>
                    <span v-if="scope.row.caseStatus==110">取消委托</span>
                </template>
                </el-table-column>
                 <el-table-column
                prop="financeState"
                label="财务状态"
                align="center"
                width="140"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.financeState==10">已开票未回款</span>
                    <span v-if="scope.row.financeState==15">已开票部分回款</span>
                    <span v-if="scope.row.financeState==20">回款完成</span>
                    <span v-if="scope.row.financeState==25">已收款未开票</span>
                    <span v-if="scope.row.financeState==30">红冲</span>
                    <span v-if="scope.row.financeState==35">作废</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="creationTime"
                label="录入时间"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="comTime"
                label="完成时间"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="kpTime"
                label="开票时间"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="city"
                label="省市区"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="addressInfo"
                label="详细地址"
                align="center"
                width="250"
                >
                
                </el-table-column>
                <el-table-column
                prop="isEndCount"
                label="是否结算"
                align="center"
                width="100"
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.isEndCount==0">未结算</span>
                    <span v-if="scope.row.isEndCount==1">已结算</span>
                </template>
                </el-table-column>
               
                <el-table-column
                prop="assessCost"
                label="评估费"
                align="center"
                width="120"
                >
                </el-table-column>
                <el-table-column
                prop="actualCost"
                label="实收评估费"
                align="center"
                width="120"
                >
                </el-table-column>

              
                
                <el-table-column
                prop="remarks"
                label="未决备注"
                align="center"
                width="300"
                >
                </el-table-column>
                <el-table-column
                prop="outRemarks"
                label="结算备注"
                align="center"
                width="300"
                >
                </el-table-column>
                <el-table-column
                fixed="right"
                label="操作"
                width="330px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-search" size="mini" @click="detail(scope.row)">查看详情</el-button>
                    <el-button type="text" icon="el-icon-delete" size="mini" @click="deleteCase(scope.row)" v-if="isHandle=='1'">删除</el-button>
                    <el-button type="text" icon="el-icon-search" size="mini" @click="relevanceDetail(scope.row)">查看关联立项</el-button>
                    <el-button type="text" icon="el-icon-date" size="mini" @click="dailyList(scope.row)">查看日志</el-button>
                </template>
                </el-table-column>
            </el-table>

            <div class="page">
                <el-pagination
                @current-change="handleCurrentChange"
                    background
                    layout="prev, pager, next,total"
                    :total="totalCount"
                    :current-page="conditionData.pageIndex"
                    :page-size="conditionData.pageSize">
                </el-pagination>
                
            </div>
        </div>


        <el-dialog :close-on-click-modal="false" :visible.sync="isDetailDialog" title="案件详情" width="860px">
            <div class="dialog">
                <div class="item">
                    <div class="label">委托日期:</div>
                    <el-input v-model="detailData.entrust" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">委托主体:</div>
                    <el-input v-model="detailData.entrustPeople" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">展业机构:</div>
                    <el-input v-model="detailData.mechanism" size="small" placeholder="" style="width:250px"></el-input>
                </div>

                <div class="item">
                    <div class="label">报案号:</div>
                    <el-input v-model="detailData.reportNo" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">报告编号:</div>
                    <el-input v-model="detailData.caseNo" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">案件名称:</div>
                    <el-input v-model="detailData.caseName" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">财务状态:</div>
                    <el-select v-model="detailData.financeState" size="small" placeholder="请选择" style="width:250px">
                        <el-option
                        v-for="item in standTermStatus"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="item">
                    <div class="label">案件创建时间:</div>
                    <el-input v-model="detailData.creationTime" size="small" placeholder="" style="width:250px"></el-input>
                </div>

                <div class="item">
                    <div class="label">省市区:</div>
                    <el-input v-model="detailData.city" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">详细地址:</div>
                    <el-input v-model="detailData.addressInfo" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">是否结算:</div>
                    <el-select v-model="detailData.isEndCount" size="small" placeholder="请选择" style="width:250px">
                        <el-option
                        v-for="item in isEndCountList"
                        :key="item.value"
                        :label="item.label"
                        :value="item.value">
                        </el-option>
                    </el-select>
                </div>
                <div class="item">
                    <div class="label">评估费:</div>
                    <el-input v-model="detailData.assessCost" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item">
                    <div class="label">实收评估费:</div>
                    <el-input v-model="detailData.actualCost" size="small" placeholder="" style="width:250px"></el-input>
                </div>
                <div class="item item-textarea">
                    <div class="label">未决备注:</div>
                    <el-input type="textarea" v-model="detailData.remarks" size="small" placeholder="" style="width:640px"></el-input>
                </div>
                <div class="item item-textarea">
                    <div class="label">结算备注:</div>
                    <el-input type="textarea" v-model="detailData.outRemarks" size="small" placeholder="" style="width:640px"></el-input>
                </div>
            </div>
        </el-dialog>
        
        <el-dialog :close-on-click-modal="false" :visible.sync="isRelevanceDetail" title="查看关联立项" width="1600px">
            <el-table
                :data="invoiceList"
                border
                :header-cell-style="tableHeaderColor"
                height="550"
                style="width: 100%">
                <!-- <el-table-column
                type="index"
                width="60"
                label="序号"
                align="center"
                >
                </el-table-column> -->
                    <el-table-column
                type="standProjectId"
                width="120"
                label="立项ID"
                align="center"
                >
                </el-table-column>
                <el-table-column
                prop="name"
                label="立项名称"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="invoiceNo"
                label="发票号"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="invoiceCode"
                label="发票编码"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <el-table-column
                prop="invoicePrice"
                label="发票金额"
                align="center"
                width="120"
                
                >
                </el-table-column>
                <el-table-column
                prop="actualPrice"
                label="实际收金额"
                align="center"
                width="120"
                >
                </el-table-column>
                <el-table-column
                prop="company"
                label="公司"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop="companyCodeName"
                label="委托公司全称"
                align="center"
                width="200"
                >
                </el-table-column>
                <el-table-column
                prop=""
                label="状态"
                align="center"
                width="200"
                
                >
                <template slot-scope="scope">
                    <span v-if="scope.row.financeState==10">已开票未回款</span>
                    <span v-if="scope.row.financeState==15">已开票部分回款</span>
                    <span v-if="scope.row.financeState==20">回款完成</span>
                    <span v-if="scope.row.financeState==25">已收款未开票</span>
                    <span v-if="scope.row.financeState==0">其他</span>
                    <span v-if="scope.row.financeState==30">红冲</span>
                    <span v-if="scope.row.financeState==35">作废</span>
                </template>
                </el-table-column>
                <el-table-column
                prop="invoicingTime"
                label="开票时间"
                align="center"
                width="160"
                >
                </el-table-column>
                <el-table-column
                prop="creatTime"
                label="创建时间"
                align="center"
                width="160"
                
                >
                </el-table-column>
                <!-- <el-table-column
                fixed="right"
                label="操作"
                width="150px"
                align="center"
                >
                <template slot-scope="scope">
                    <el-button type="text" icon="el-icon-search" size="mini" @click="relevanceItemDetail(scope.row)">查看详情</el-button>
                </template>
                </el-table-column> -->
            </el-table>
            <div class="page">
                <el-pagination
                    @current-change="handleCurrentInvoiceChange"
                    background
                    layout="prev, pager, next ,sizes ,total"
                    :total="invoiceCount"
                    :current-page="conditionInvoiceData.pageIndex"
                    :page-sizes="[10, 20, 50, 100]"
                    :page-size="conditionInvoiceData.pageSize">
                </el-pagination>
                
            </div>
        </el-dialog>

        <el-dialog :close-on-click-modal="false" :visible.sync="isDailyDialog" title="查看日志" width="800px">
            <el-timeline>
                <el-timeline-item :timestamp="item.cDateTime" placement="top" v-for="(item,index) in daily" :key="index">
                <p> 
                    {{item.behavior==0?'插入':''}}
                    {{item.behavior==1?'更新':''}}
                    {{item.behavior==2?'单个关联':''}}
                    {{item.behavior==3?'批量关联':''}}
                    {{item.behavior==4?'取消关联':''}}
                </p>
                </el-timeline-item>
               
            </el-timeline>
        </el-dialog>
    </div>
</template>
<script>
import api from '../../../api/main'
import {parseTimeS,parseTimeD} from '../../../utils/index'
import {assetStandTermStatus,carTypeList,companyTypeList,businessModuleList} from '../../../assets/selectList/assetsSelectList'
export default {
    name: 'person',
    components:{
        
    },
    watch: {
    },
    data () {
        return {
            standTermStatus:assetStandTermStatus,
            time:'',
            title:'',
            isDetailDialog:false,
            totalCount:0,
            conditionData:{
                IsJoinCase:null,
                Multiple:"",
                StartTime:"",
                EndTime:"",
                CompanyName:"",
                financeState:null,
                pageIndex:1,
                pageSize:10,
                CaseStates:null
            },
            isEndCountList:[
                {
                    label:'全部',
                    value:null,
                },
                {
                    label:'未结算',
                    value:0,
                },{
                    label:'已结算',
                    value:1,
                },
            ],
            dcTaskActionList:[
                {
                    label:'全部',
                    value:null,
                },{
                    label:'已指派待作业',
                    value:10,
                },{
                    label:'作业中',
                    value:20,
                },{
                    label:'待审核',
                    value:30,
                },{
                    label:'审核退回',
                    value:35,
                },{
                    label:'审核通过',
                    value:102,
                },{
                    label:'待归档',
                    value:101,
                },{
                    label:'完成',
                    value:100,
                },{
                    label:'取消委托',
                    value:110,
                }
            ],
            catastyppes:
            [
            {
                    label:'全部',
                    value:0
                },
                {
                    label:'财产险',
                    value:1
                },{

                    label:'资产评估',
                    value:2
                }
            ],
            tableData:[],
            detailData:{},
            // financeStateList:[
            //     {
            //         label:'全部',
            //         value:'全部',
            //     },{
            //         label:'待受理',
            //         value:'待受理',
            //     },{
            //         label:'待作业',
            //         value:'待作业',
            //     },{
            //         label:'作业中',
            //         value:'作业中',
            //     },{
            //         label:'作业完成',
            //         value:'作业完成',
            //     },{
            //         label:'完成',
            //         value:'完成',
            //     },{
            //         label:'不受理',
            //         value:'不受理',
            //     },{
            //         label:'已取消',
            //         value:'已取消',
            //     },
            // ],

            isRelevanceDetail:false,
            conditionInvoiceData:{
                Multiple:"",
                StartTime:"",
                EndTime:"",
                Company:"",
                financeState:null,
                pageIndex:1,
                pageSize:10,
            },
            invoiceList:[],
            invoiceCount:0,
            row:null,

            isDailyDialog:false,
            daily:[
                
            ],
            isHandle:localStorage.getItem('isHandle')
        }
    },
    created(){
        

    },
    mounted(){
        this.loadingData();
    },
    methods:{
        async dailyList(row){
            this.isDailyDialog = true;
            let res = await api.externalQueryCaseLogs({
                "caseID": row.assetsID+'',
                "caseType": 6
            });
            this.daily = res.data.data;
        },
        handleCurrentInvoiceChange(pageIndex){
            this.conditionInvoiceData.pageIndex = pageIndex;
            this.relevanceDetail(this.row);
        },
        async relevanceDetail(row){
            console.log(row);
            this.row = row;
            this.isRelevanceDetail = true;
            this.conditionInvoiceData.RelationID = row.relatedID;
            this.conditionInvoiceData.pageIndex=1;
            let res  = await api.getAssetsList(this.conditionInvoiceData);
            this.invoiceList = res.data.data.entitys;
            this.invoiceCount = res.data.data.pageLen;
            for(let i in this.invoiceList){
                this.invoiceList[i].billingTimeStr = parseTimeD(this.invoiceList[i].billingTime)
            }
        },
        relevanceItemDetail(row){
            localStorage.setItem('editData',JSON.stringify(row));
            const { href } = this.$router.resolve({
                name: "carInsuranceDetail",
                query:{
                    id:row.standProjectId,
                    isDetail:true,
                }
            });
            window.open(href, '_blank');
        },


        async deleteCase(row){
            console.log(row);
            this.$confirm('是否删除此数据?', '提示', {
                confirmButtonText: '确定',
                cancelButtonText: '取消',
                type: 'warning'
            }).then(() => {
                this.deleteCaseFun(row);
            }).catch(() => {
                this.$message({
                    type: 'info',
                    message: '已取消删除'
                });          
            });
        },
        async deleteCaseFun(row){
            let res  = await api.deleteAssets({id:row.assetsID});
            if(res.data.code == 200){
                this.$message({
                    message: '删除成功',
                    type: 'success'
                });
                this.loadingData();
            }
        },
        tableHeaderColor ({ row, column, rowIndex, columnIndex }) {
            if (rowIndex === 0) {
                return 'background-color: #F2F2F2;color: #000;'
            }
        },
        async loadingData() {
            if(this.time){
                this.conditionData.StartTime = parseTimeD(this.time[0]);
                this.conditionData.EndTime = parseTimeD(this.time[1]);
            }
            let res  = await api.queryAssetss(this.conditionData);
            console.log(res);
            this.tableData = res.data.data.entitys;
            this.totalCount = res.data.data.pageLen;
            for(let i in this.tableData){
                this.tableData[i].entrust = parseTimeD(this.tableData[i].entrust)
            }
        },
        selectData(){
            this.conditionData.pageIndex = 1;
            this.loadingData();
        },
        reset(){
            this.time = "";
            this.conditionData = {
                Multiple:"",
                StartTime:"",
                EndTime:"",
                financeState:null,
                Client:"",
                isEndCount:null,
                pageIndex:1,
                pageSize:20,
                CaseStates:null
            },
            this.loadingData();
        },
        handleCurrentChange(pageIndex){
            this.conditionData.pageIndex = pageIndex;
            this.loadingData();
        },
        
        detail(row){
            this.detailData = row;
            this.isDetailDialog = true;
        },
        async getExcel(){
            let option = {
                Multiple:this.conditionData.Multiple,
                StartTime:this.conditionData.StartTime,
                EndTime:this.conditionData.EndTime,
                isEndCount:this.conditionData.isEndCount,
                financeState:this.conditionData.financeState,
                Client:this.conditionData.Client,
                CaseStates:this.conditionData.caseStatus
            }
            let res = await api.assetsExport(option);
        },
    }
    
}
</script>

<style lang="scss" scoped>
    .condition{
        background-color: #ffffff;
        display: flex;
        align-items: center;
        flex-wrap: wrap;
        border-radius: 5px;
        padding: 8px 15px;
        font-size: 14px;
        .item{
            display: flex;
            align-items: center;
            padding: 7px;
            .label{
                min-width: 110px;
            }
        }
        .btns{
            margin-left: 20px;
        }
    }
    .table{
        margin-top: 10px;
        background-color: #ffffff;
        padding: 15px;
        .handle{
            width: 100%;
            display: flex;
            justify-content: space-between;
            padding-bottom: 15px;
            align-items: center;
            font-size: 20px;
        }
        .page{
            display: flex;
            align-items: center;
            justify-content: space-between;
            margin-top: 16px;
            .el-pagination{
                margin-left: -10px;
            }
        }
    }

    .dialog{
        padding-top: 20px;
        height: 100%;
        display: flex;
        flex-wrap: wrap;
        .item{
            font-size: 14px;
            padding:10px 15px;
            display: flex;
            align-items: center;
            .label{
                min-width: 110px;
                margin-bottom: 5px;
            }
        }
        .item-textarea{
            width: 760px;
        }
        .dialog-footer{
            display: flex;
            padding:10px 15px;
            flex-direction: row-reverse;
            .el-button{
                margin-left: 20px;
            }
        }
    }
</style>
